import { css } from '@emotion/react'
import { CSSProperties } from 'react'

// https://stackoverflow.com/questions/27233295/possible-to-make-border-radius-equal-to-half-the-total-height-without-javascript/27233380
const fullyRounded = css`
	border-radius: 9999px;
`

type CornerTypes = 'square' | 'round' | 'rounder'

const CornerValues: Record<CornerTypes, CSSProperties['borderRadius']> = {
	round: '0.5rem',
	rounder: '1rem',
	square: 0
}

export interface CornerProps {
	corners?: CornerTypes
}

export const CornerMods = ({ corners }: CornerProps) => css`
	border-radius: ${corners && CornerValues[corners]};
`

CornerMods.FullyRounded = fullyRounded
CornerMods.Round = CornerMods({ corners: 'round' })
CornerMods.Rounder = CornerMods({ corners: 'rounder' })
CornerMods.Square = CornerMods({ corners: 'square' })
